import { Add, Image } from 'assets/icons/revamp';
import BaseButton from 'components/ui/BaseButton';
import Card from 'components/ui/Card';
import FloatingLabelInput from 'components/ui/FloatingLabelInput';
import COLOR from 'constants/color';
import { KEY_BOARD } from 'constants/general';
import { ActivityImageStatus } from 'constants/image';
import { t } from 'services/i18n.service';
import ImagesList from './ImagesList';
import { useAppDispatch } from 'store/hooks';
import { useState } from 'react';
import { useActivityInstructionImagesDraftContext } from 'contexts/ActivityInstructionImagesDraftContext';

export type ImageStatus = ActivityImageStatus;

const Images = () => {
  const dispatch = useAppDispatch();
  const { addDraftUrl } = useActivityInstructionImagesDraftContext();
  const [imageStatuses, setImageStatuses] = useState<
    Record<string, ImageStatus>
  >({});
  const [imageUrlInput, setImageUrlInput] = useState('');

  const handleAddImageUrl = () => {
    const trimmed = imageUrlInput.trim();
    if (trimmed) {
      addDraftUrl(trimmed, dispatch);
      setImageUrlInput('');
    }
  };

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex ~gap-2/3'>
        <Image
          styles='~w-4/5 ~h-4/5 flex-shrink-0 mt-0.5'
          fill={COLOR.PRIMARY.LIGHT_900}
        />
        <h3 className='~text-xs/sm font-semibold text-black dark:text-white flex flex-col'>
          {t('tabs_revamp.instructions_tab.add_images')}
          <p className='~text-[0.625rem]/xs text-gray-500 dark:text-gray-400 font-normal'>
            {t('tabs_revamp.instructions_tab.add_images_description')}
          </p>
        </h3>
      </div>

      <div className='flex flex-col ~gap-3/4 ~ml-0/0'>
        <div className='flex items-center ~gap-2/3'>
          <div className='flex-1'>
            <FloatingLabelInput
              type='text'
              placeholder={t('tabs_revamp.instructions_tab.image_url')}
              value={imageUrlInput}
              onChange={(e) => setImageUrlInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === KEY_BOARD.ENTER.KEY) {
                  handleAddImageUrl();
                }
              }}
              size='small'
              variant='default'
              showLabel={true}
              label=''
            />
          </div>
          <BaseButton
            title={t('tabs_revamp.instructions_tab.add_url')}
            onClick={handleAddImageUrl}
            size='xs'
            icon={<Add styles='~w-3/4 ~h-3/4' fill={COLOR.PRIMARY.LIGHT_900} />}
            variant='secondary'
          />
        </div>

        <ImagesList
          imageStatuses={imageStatuses}
          setImageStatuses={setImageStatuses}
        />
      </div>
    </Card>
  );
};

export default Images;
